/* global MdlButton */
/* eslint no-undef: "error"*/
import { Textfield } from 'react-mdl'
import classNames from 'classnames'
const { Fragment, useState } = React
const _ = window._

const blankOption = {
  id: '',
  content: '',
}

const defaultPrevented = (fn) => (event) => {
  event.preventDefault()

  return fn(event)
}

const normalize = (locale) => {
  if (locale === 'en-US') return ''

  const prefix = '_'
  const content = locale.replace('-', '_').toLowerCase()

  return `${prefix}${content}`
}

const Select = ({
  className,
  error,
  includeBlankOption,
  inputId,
  label,
  name,
  options,
  style,
  selectedId,
  onChange,
}) => {
  const fullOptions = includeBlankOption ? [blankOption, ...options] : options
  const idArray = fullOptions.map((opt) => opt.id)

  const indexOfSelected = idArray.indexOf(selectedId)
  const selected = indexOfSelected === -1 ? 0 : indexOfSelected

  const [selectedIdx, setSelectedIdx] = useState(selected)

  const handleChange = defaultPrevented((e) => {
    setSelectedIdx(idArray.indexOf(e.target.value))
    if (onChange) {
      onChange(e)
    }
  })

  return (
    <div
      className={classNames('mdl-textfield mdl-js-textfield mdl-textfield--floating-label', {
        'is-invalid': !!error,
        [className]: !!error,
      })}
      style={style || {}}>
      {/* onBlur is required to pass eslint, but it's probably not important */}
      <select
        id={inputId}
        className="mdl-textfield__input select"
        name={name}
        onBlur={() => {}}
        onChange={handleChange}
        value={fullOptions[selectedIdx].id}>
        {fullOptions.map((option, i) => {
          return (
            <option key={i} value={option.id}>
              {option.content}
            </option>
          )
        })}
      </select>
      <label className="mdl-textfield__label" htmlFor={inputId}>
        {label}
      </label>
      {error && <span className="mdl-textfield__error">{error}</span>}
    </div>
  )
}

const HiddenInput = ({ value, name }) => {
  return <input aria-hidden="true" type="text" hidden value={value} name={name} readOnly />
}

const LocalizedInputs = ({ baseName, group, showLocale }) => {
  return (
    <Fragment>
      <HiddenInput value={group.id} name={`${baseName}[][id]`} />
      {group.localized_attributes.map((localized, index) => {
        const inputId = `${localized.key}-${index}`
        const label = showLocale
          ? I18n.t('events.views.program_event_settings.event_settings_event_name', {
              locale_code: localized.locale_code,
            })
          : I18n.t('events.views.program_event_settings.event_settings_event_name_single_language')
        return (
          <Textfield
            floatingLabel
            key={`name_input-${localized.key}-${index}`}
            id={inputId}
            label={label}
            name={`${baseName}[][${localized.key}]`}
            defaultValue={localized.value}
            placeholder={label}
            className="mr-5"
          />
        )
      })}
    </Fragment>
  )
}

const EventNameGroup = ({ nameGroup, showLocale }) => {
  const baseName = 'event_settings[program_event_names_attributes]'
  return (
    <tr>
      <td className="mdl-data-table__cell--non-numeric px-10">
        <LocalizedInputs group={nameGroup} baseName={baseName} showLocale={showLocale} />
      </td>
    </tr>
  )
}

const AddNameButton = ({ onClick }) => {
  return (
    <MdlButton className="mdl-button--colored" onClick={onClick}>
      <span className="material-icons" aria-hidden="true">
        add
      </span>
      {I18n.t('events.views.event_settings.add_name')}
    </MdlButton>
  )
}

const emptyNameGroup = (supportedLocales) => {
  return {
    id: '',
    localized_attributes: supportedLocales.map((locale) => {
      const suffix = normalize(locale.iso_code)
      const attribute = `value${suffix}`
      return {
        locale_code: locale.iso_code,
        key: attribute,
        [attribute]: '',
      }
    }),
  }
}

const EventSettingsEventNaming = ({
  eventNameSettingOptions,
  eventNameSetting,
  configuredEventNames,
  supportedLocales,
}) => {
  const [emptyGroups, setEmptyGroups] = useState([])
  const [selectedEventNameSetting, setSelectedEventNameSetting] = useState(eventNameSetting)

  const handleAddName = defaultPrevented(() => {
    setEmptyGroups([...emptyGroups, emptyNameGroup(supportedLocales)])
  })

  const multiLanguage = supportedLocales.length > 1

  return (
    <Fragment>
      <p>{I18n.t('events.views.program_event_settings.event_name_options_note')}</p>
      <Select
        onChange={(e) => setSelectedEventNameSetting(e.target.value)}
        name="event_settings[event_name_setting]"
        inputId={_.uniqueId('select-')}
        selectedId={eventNameSetting}
        label={'Event Name Setting'}
        options={eventNameSettingOptions}
        includeBlankOption
      />

      <div id="event_name_list_container">
        <div className="u-margin--bottom-20">
          <table
            id="event_name_list_table"
            className="mdl-data-table mdl-js-data-table block--full text--darkgray">
            <tbody className="list">
              {[...configuredEventNames, ...emptyGroups].map((nameGroup, index) => (
                <EventNameGroup
                  key={`grouping-${index}`}
                  nameGroup={nameGroup}
                  showLocale={multiLanguage}
                />
              ))}
            </tbody>
          </table>
        </div>
        {selectedEventNameSetting === 'configured_name' ? (
          <AddNameButton onClick={handleAddName} />
        ) : null}
      </div>
    </Fragment>
  )
}

export default EventSettingsEventNaming
